var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.297 7.999v6.825h12.106V7.999L7.35 1.946a559.358 559.358 0 0 1-6.053 6.053Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.434 7.999 7.38 1.946c-1.205 1.173-2.131 2.1-3.057 3.026L1.297 7.999v1.39L7.35 3.334l6.053 6.053v.186-1.575h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27 14.824H2.624V11.24c0-1.019.834-1.822 1.822-1.822 1.02 0 1.822.834 1.822 1.822v3.583ZM7.35 9.419h4.756v4.169H7.35z",
    fill: "var(--tru-gunmetal)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.844 9.914h1.637v3.18H7.844zM9.975 9.914h1.637v3.18H9.975z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.546 6.732 8.09.278c-.37-.37-1.019-.37-1.39 0L.278 6.732c-.37.37-.37 1.02 0 1.39.37.37 1.02.37 1.39 0l5.744-5.744 5.744 5.744c.37.37 1.019.37 1.39 0 .37-.401.37-1.02 0-1.39Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default ForwardRef;